import { DataAccessPolicyRow } from '../../list';
import { DATA_ACCESS_POLICY_VALUES } from './constant';
import { DataAccessPolicyValues } from './types';


export interface DefaultValueProps {
  existingDataAccessPolicy: DataAccessPolicyRow;
}
export const getDefaultValues = (props: DefaultValueProps) => {
  const { existingDataAccessPolicy } = { ...props };

  const {
    __typename,
    id,
    _isUpdatable,
    _isDeletable,
    _rowTimestamp,
    dataAccessBusinessUnits,
    ...dataAccessPolicyFields
  } = {
    ...existingDataAccessPolicy,
  };
  let defaultValues: DataAccessPolicyValues = DATA_ACCESS_POLICY_VALUES;

  if (!!id) {
    const dataAccessBusinessUnitsFields =
      dataAccessBusinessUnits?.nodes?.map(
        ({ businessUnit, ...businessUnitField }) => ({ ...businessUnitField })
      ) || [];
    defaultValues = {
      ...dataAccessPolicyFields,
      dataAccessBusinessUnits: !!dataAccessBusinessUnitsFields.length
        ? dataAccessBusinessUnitsFields
        : [],
    };
  }
  return defaultValues;
};
